'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduxQuestionField;
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFinalForm = require('react-final-form');
var _recompose = require('recompose');
var _fieldToQuestion = require('./fieldToQuestion');
var _fieldToQuestion2 = _interopRequireDefault(_fieldToQuestion);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _validate(question, validator, requiredText, /* Validator arguments */
value, allValues, fieldProps) {
  var isRequired = question.isRequired;
  var isUnanswered = value == null || value === '' || value === [];
  if (isRequired && isUnanswered) {
    return [requiredText];
  }
  if (!isRequired && isUnanswered) {
    return undefined;
  }
  return validator(value, allValues, fieldProps);
}
function reduxQuestionField(questions, requiredText) {
  return function generateReduxQuestionField(Component) {
    /* Maps props from redux-form into generic Question props */
    var EnhancedComponent = (0, _fieldToQuestion2.default)(Component);

    /* "Prebakes" props that are required for the Field component from redux-form */
    var ReduxQuestionField = (0, _recompose.withProps)(function (props) {
      var question = questions.find(function (questionConfig) {
        return questionConfig.slug === props.slug;
      });
      return {
        name: props.slug,
        component: EnhancedComponent,
        // Commented out because of https://github.com/final-form/final-form/issues/75
        // validateFields: [],
        validate: function validate(_value, _allValues, _fieldProps) {
          var validator = question.validate || function noop() {};
          return _validate(question, validator, requiredText, _value, _allValues, _fieldProps);
        },
        parse: question.parse,
        format: question.format
      };
    })(_reactFinalForm.Field);
    ReduxQuestionField.propTypes = {
      slug: _propTypes2.default.string.isRequired
    };
    return ReduxQuestionField;
  };
}